<!--*
 * Modal to show how to use the application
 *
 * @author   pablo.barco
 * @date     2024-22-01
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div class="d-flex justify-content-center p-5 mt-9">
      <div class="card">
        <div class="card-img-top" />
        <div class="px-5 pb-5">
          <div class="mt-4 title">{{ $t('login.title.label') }}</div>
          <div>{{ $t('about.subtitle') }}</div>
          <div class="mt-4">
            <span class="label">{{ $t('about.app.version.label') }}: </span><span>{{ version }}</span>
          </div>
          <div v-if="releaseDate">
            <span class="label">{{ $t('about.app.releaseDate') }}: </span><span>{{ releaseDate }}</span>
          </div>
          <div class="text-center mt-4">
            {{ $t('about.app.copyright') }}
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  'name': 'AboutDetails',
  'computed': {
    version(){
      return this.$store.state.loggedUser.appVersion
    },
    releaseDate() {
      const { releaseDate } = this.$store.getters.GetUserData();
      return releaseDate
        ? new Date(releaseDate).toLocaleDateString(this.$i18n.locale(), { year: 'numeric', month: 'long', day: 'numeric' })
        : null;
    }
  }
}
</script>

<style scoped>

.title {
  font-weight: bold;
  font-size: 20px;
}

.card-img-top {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 200px;
  background-image: url('../../../assets/images/login-background.jpg');
  background-size: cover;
  background-position: center;
}

.card {
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);
  border:none;
  width: 100%;
  max-width: 700px;
}

.label {
  font-weight: bold;
}

</style>
